<template>
  <Modal
    :confirmationText="'Create School'"
    :darker="true"
    :headerTitle="'Add new school'"
    :isAboveAll="true"
    :id="'create-school-modal'"
    :showButtonLoader="loading"
    @confirm="saveSchool()"
    @closeModal="$emit('close')"
  >
    <template #content>
      <form class="form-container" @submit.prevent="saveSchool()">
        <!-- Name -->
        <label
          for="form-name"
          class="input-container"
          :class="{ error: errors.name }"
        >
          <div class="sidebar-option-title">
            <span>Name</span>
          </div>
          <input
            id="form-name"
            class="input-style"
            type="text"
            v-model="name"
            @input="errors.name && checkForm(false)"
          />
          <span class="error-msg" v-if="errors.name">Missing name</span>
        </label>

        <!-- City -->
        <label
          for="form-city"
          class="input-container"
          :class="{ error: errors.city }"
        >
          <div class="sidebar-option-title">
            <span>City</span>
          </div>
          <input
            id="form-city"
            class="input-style"
            type="text"
            v-model="city"
            @input="errors.city && checkForm(false)"
          />
          <span class="error-msg" v-if="errors.city">Missing city</span>
        </label>

        <!-- State -->
        <label
          for="form-state"
          class="input-container"
          :class="{ error: errors.state }"
        >
          <div class="sidebar-option-title">
            <span>State</span>
          </div>
          <input
            id="form-state"
            class="input-style"
            type="text"
            v-model="state"
            @input="errors.state && checkForm(false)"
          />
          <span class="error-msg" v-if="errors.state">Missing state</span>
        </label>

        <!-- Mascot -->
        <label
          for="form-mascot"
          class="input-container"
          :class="{ error: errors.mascot }"
        >
          <div class="sidebar-option-title">
            <span>mascot</span>
          </div>
          <input
            id="form-mascot"
            class="input-style"
            type="text"
            v-model="mascot"
            @input="errors.mascot && checkForm(false)"
          />
          <span class="error-msg" v-if="errors.mascot">Missing mascot</span>
        </label>
      </form>

      <!-- Color Picker -->
      <div class="colors-column">
        <ColorPicker
          :allowNoneColorOption="true"
          :colorPickerMode="'multiple'"
          :colorsToChange="colorsToChange"
          :componentKey="'color-picker-for-new-school'"
          @selectColor="handleSelectColor"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";
import Modal from "@/components/Utils/Modal.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "CreateSchoolModal",

  components: { ColorPicker, Modal },

  data() {
    return {
      name: "",
      city: "",
      state: "",
      mascot: "",
      colorsToChange: [
        { key: "color_1", label: "main" },
        { key: "color_2", label: "second" },
        { key: "color_3", label: "third" },
      ],
      errors: {},
      user_id: "",
      loading: false,
    };
  },

  computed: {
    ...mapState("project", ["temporaryNewSchool"]),
    ...mapGetters("project", ["isPlaybook"]),
    has_errors() {
      return Object.keys(this.errors).length > 0;
    },
  },

  methods: {
    ...mapActions("project", ["setTemporaryNewSchool"]),
    ...mapActions("playbook", ["bulkUpdatePlaybook"]),

    handleSelectColor({ color, colorKey }) {
      const newColors = this.colorsToChange.map((colorToChange) => {
        if (colorToChange.key === colorKey) {
          colorToChange.color = { ...color };
        }
        return { ...colorToChange };
      });

      this.colorsToChange = newColors;
    },

    checkForm: function (showToast = true) {
      this.errors = {};

      //Check inputs
      const inputs = ["name", "city", "state", "mascot"];

      inputs.forEach((input) => {
        if (!this[`${input}`]?.trim()) {
          this.errors[`${input}`] = `School's ${input} required.`;
        } else if (this[`${input}`].length > 100) {
          this.errors[`${input}`] = `School's ${input} too long.`;
        }
      });

      //Check Colors

      this.colorsToChange.forEach((color) => {
        if (!color.color) this.errors["colors"] = "Missing colors";
      });

      if (!Object.keys(this.errors).length) {
        return true;
      }

      showToast &&
        this.$store.dispatch("showToast", {
          txt: "Please verify your information is correct",
          type: "error",
        });
      return false;
    },

    async saveSchool() {
      if (this.checkForm()) {
        if (this.isPlaybook) {
          this.$emit("close");
          await this.bulkUpdatePlaybook({
            title: this.name,
            team_name: this.mascot,
            color_1: this.colorsToChange[0].color.id,
            color_2: this.colorsToChange[1].color.id,
            color_3: this.colorsToChange[2].color.id,
          });

          this.setTemporaryNewSchool({
            city: this.city,
            state: this.state,
          });
        }
      }
    },
  },

  mounted() {
    this.name = this.temporaryNewSchool.name;
    this.city = this.temporaryNewSchool.city;
    this.state = this.temporaryNewSchool.state;
    this.mascot = this.temporaryNewSchool.mascot;
  },
};
</script>

<style lang="scss">
#create-school-modal {
  .modal-container {
    width: 50% !important;
    max-width: 850px;
    margin: auto;
    background: white;
    border-radius: 6px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.2rem;
      border-bottom: 1px solid $grey-light;
      p {
        text-transform: capitalize;
        margin-right: auto;
        margin-left: 0.5rem;
      }
    }

    .content {
      display: flex;
      flex-direction: row;
      padding: 1.3rem 1.5rem;
      gap: 2rem;
      p.text {
        color: $grey-dark;
      }

      .form-container {
        width: 45%;
        .input-container {
          width: 100%;
          &.error {
            label {
              color: $redError;
            }
            input,
            textarea,
            .input-style {
              border: 2px solid $redError;
            }

            span {
              color: $redError;
            }

            span.error-msg {
              color: $redError;
              font-size: 0.8em;
              margin-top: 0.25rem;
              text-align: left;
            }
          }

          .sidebar-option-title {
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            text-transform: capitalize;
            width: 100%;
            span {
              margin-right: 1rem;
            }
          }

          .input-style {
            width: 100%;
            padding: 0.75rem;
            background: white;
            border: 1px solid $grey-light;
            border-radius: 6px;

            &.select {
              padding: 0;
              border: none;
              ::v-deep {
                .vs__dropdown-toggle {
                  border-radius: 6px;
                  border: 1px solid $grey-light;
                  padding: 0.5rem;
                }
              }
            }
          }
        }
      }

      .phone-mask-container {
        input {
          width: 30%;
        }
      }
      .show-extension-switch {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .colors-column {
        width: 50%;
        display: flex;
        flex-flow: column;
        overflow-y: visible;
        border: 1px solid transparent;
        /* justify-content: center; */
        .color-picker-multiple-container {
          z-index: 100;
          max-height: 500px;
          overflow-y: scroll;
          border: 10px;
          box-shadow: 0px 9px 8px 4px #1616161c;
        }

        &.error {
          border: 1px solid $redError;
        }

        .error-text {
          color: white;
          margin-bottom: 1.5rem;
          padding: 0.5rem;
          background: $redError;
          border-radius: 10px;
          width: max-content;
        }

        .show-extension-switch {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .rep-preview-container {
        width: 45%;
        display: flex;
        flex-flow: column;
        /* justify-content: center; */

        .text-info {
          color: $grey-dark;
          margin-bottom: 1.5rem;
        }

        .rep-info {
          border-left: 1px solid $grey-light;
          padding-left: 1rem;
          h3 {
            margin-bottom: 0.5rem;
          }

          p {
            overflow-wrap: break-word;
          }
        }
      }

      /* .url-container {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eaeaea;
      border-radius: 6px;
      overflow: hidden;
      .url {
        padding: 0.5rem;
        color: $dark;
        text-decoration: underline;
      }

      button {
        background-color: $dark;
        border-radius: 0 !important;
        color: white;
        padding: 0 0.5rem;
      }
    }

    p.msg {
      padding: 0.5rem 0;
      color: $green;
    } */
    }

    .buttons-container {
      display: flex;
      padding: 1.3rem 1.5rem;
      gap: 1rem;
      justify-content: flex-end;
      .btn {
        &.confirm {
          background: $dark;
          display: flex;
          align-items: center;
          color: white;
          text-transform: capitalize;
        }
      }
    }

    @media screen and (max-width: 1440px) {
      width: 50%;
    }
  }
}
</style>
